import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getAffiliates,} from '../../../actions/Admin'
import AdminDashboardMenu from './AdminDashboardMenu';
import TopNav from '../../includes/TopNav.js';
import { Link } from 'react-router-dom';
import {getUserSession} from '../../../actions/user.js';

class AdminAffiliates extends Component {
  constructor(props) {
    super(props);
    this.getUserSession();
  }
  getUserSession(){
    console.log('getting user session');
    this.props.dispatch(getUserSession(ret => {
      if(ret !== false && ret.user.role !== 'admin') {
        window.location.href = "/login";
      } else if(ret === false) {
        window.location.href = "/login";
      }
    }));
  }
  componentDidMount() {
    this.getAffiliates()
  }
  getAffiliates() {
    this.props.dispatch(getAffiliates(() => {

    }))
  }
  render() {
    return(
      <div>
        <TopNav />
        <br/><br/>
        <section className="admin-container">
          <AdminDashboardMenu />
          <div className="admin-form">
            <div className="adminDashboardTabTitle">Affiliates</div>
            <h5>Showing top 50 affiliators</h5>
            <div>
              <table className="adminTable">
                <tbody>
                <tr>
                  <th>User Email</th>
                  <th>Current Balance</th>
                  <th>Total Balance Used</th>
                  <th># Affiliated Customers</th>
                </tr>
                {this.props.Admin.affiliates.map((user, i) => {
                return(
                  <tr key={i}>
                    <td><Link to={"/admindashboard/affiliate/"+user.affiliate_code}>{user.email}</Link></td>
                    <td>{user.balance}</td>
                    <td>{user.spent}</td>
                    <td>{user.count_affiliated}</td>
                  </tr>
                )
              })}
                </tbody>
              </table>
              <p>Pagination placeholder, if needed</p>
            </div>
          </div>
        </section>
      </div>
    )
  }

}

export default connect( ({Dashboard, Admin, AdminDocument, AdminUserCollection}) => ({Dashboard, Admin, AdminDocument, AdminUserCollection}) ) (AdminAffiliates)



// WEBPACK FOOTER //
// ./src/components/dashboards/AdminDashboard/Affiliates.js